































































import { Component, Prop, Vue } from "vue-property-decorator";
import UploadingImagesToServer from "@/components/app/images/uploading-images-to-server.vue";
import GalleryFolderList from "@/components/tables/gallery/gallery-folder-list.vue";
import InputSearch from "@/components/app/search/input-search.vue";
import ButtonBack from "@/components/buttons/button-back.vue";
import StandartModal from "@/components/app/standart-modal.vue";

import { IGallery } from "@/@types/gallsery/gallery";
import { pics, gallerys } from "@/config/host.config";
import axios from "@/api/AuthAPI/auth-request-api";

@Component({
  components: {
    StandartModal,
    UploadingImagesToServer,
    GalleryFolderList,
    InputSearch,
    ButtonBack,
  },
})
export default class GalleryList extends Vue {
  @Prop({ type: Array, default: () => [] }) gallerys!: Array<IGallery>;
  @Prop({ type: String, default: "" }) activeGallery!: string;
  @Prop({ type: String, default: "" }) activeCategory!: string;

  search = "";
  host = pics.gallery;

  get photoFolder(): string {
    let folder = "";
    if (this.activeCategory) folder += `${this.activeCategory}`;
    folder += `gallery_${this.activeGallery}`;
    return folder;
  }

  get gallery(): IGallery | undefined {
    if (!this.activeGallery) return undefined;
    return this.gallerys.find((el: IGallery) => el._id == this.activeGallery);
  }

  get photos(): Array<string> {
    if (!this.gallery) return [];
    return this.gallery.photos.filter((item: string) => {
      return (
        this.$getLocale(item).toLowerCase().indexOf(this.search.toLowerCase()) >
        -1
      );
    });
  }

  async deleteOllPhotos(): Promise<void> {
    if (!this.gallery) return;
    const uri = gallerys.mainAPI + "/" + this.activeGallery;
    try {
      const clearPhotos = await axios.delete(uri);
      if (clearPhotos.status === 200) {
        const gallery = this.gallery;
        gallery.photos = [];
        this.$emit("updateGallery", gallery);
      }
    } catch (error) {
      this.$notify({
        group: "global",
        text: String(this.$i18n.t("alerts.emptyUpdate")),
        type: "warn",
      });
    }
  }

  async dropFoler(): Promise<void> {
    if (!this.gallery) return;
    const uri = gallerys.force + "/" + this.activeGallery;
    try {
      const clearPhotos = await axios.delete(uri);
      if (clearPhotos.status === 200) {
        this.$notify({
          group: "global",
          text: String(this.$i18n.t("error.200")),
        });
        this.$emit("dropGallery");
        this.$router.go(-1);
      }
    } catch (error) {
      this.$notify({
        group: "global",
        text: String(this.$i18n.t("alerts.emptyUpdate")),
        type: "warn",
      });
    }
  }

  deletePhoto(id: string): void {
    if (!id || !this.gallery) return;
    const photos = this.gallery.photos.slice();
    const i = photos.indexOf(id);
    if (i != -1) photos.splice(i, 1);
    const gallery = this.gallery;
    gallery.photos = photos;
    this.$emit("updateGallery", gallery);
  }

  addPhoto(id: string): void {
    if (!id || !this.gallery) return;
    const photos = this.gallery.photos.slice();
    photos.push(id);
    const gallery = this.gallery;
    gallery.photos = photos;
    this.$emit("updateGallery", gallery);
  }
}
